/* Raaga header / footer behaviour: promo rotation, menu drawer, header height, WhatsApp tab. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function promo(root) {
    (root || document).querySelectorAll('[data-rg-promo]').forEach(function (el) {
      if (el.dataset.rgBound) return;
      el.dataset.rgBound = 'true';
      var msgs = el.querySelectorAll('.rg-promo__m');
      if (msgs.length < 2 || reduce) return;
      var i = 0;
      var ms = Number(el.getAttribute('data-interval')) || 4200;
      setInterval(function () {
        el.style.opacity = 0;
        setTimeout(function () {
          msgs[i].hidden = true;
          i = (i + 1) % msgs.length;
          msgs[i].hidden = false;
          el.style.opacity = 1;
        }, 220);
      }, ms);
    });
  }

  function drawers(root) {
    (root || document).querySelectorAll('[data-rg-open]').forEach(function (btn) {
      if (btn.dataset.rgBound) return;
      btn.dataset.rgBound = 'true';
      var d = document.getElementById(btn.getAttribute('data-rg-open'));
      if (!d) return;
      function onKey(e) { if (e.key === 'Escape') close(); }
      function open() {
        d.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', onKey);
        requestAnimationFrame(function () {
          d.classList.add('on');
          setTimeout(function () { var c = d.querySelector('[data-rg-close]'); if (c) c.focus(); }, 60);
        });
      }
      function close() {
        if (!d.classList.contains('on')) return;
        d.classList.remove('on');
        btn.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        btn.focus();
      }
      btn.addEventListener('click', open);
      d.addEventListener('click', function (e) { if (e.target === d || e.target.closest('[data-rg-close]')) close(); });
    });
  }

  /* desktop nav dropdowns: CSS does the showing on :hover/:focus-within, this
     mirrors that into aria-expanded, closes on Escape, and gives touch screens
     a first tap that opens instead of navigating. */
  function subnav(root) {
    var coarse = window.matchMedia && window.matchMedia('(hover: none)').matches;
    (root || document).querySelectorAll('[data-rg-sub]').forEach(function (item) {
      if (item.dataset.rgBound) return;
      item.dataset.rgBound = 'true';
      var top = item.querySelector('.rg-links__top');
      if (!top) return;

      function mark(open) { top.setAttribute('aria-expanded', open ? 'true' : 'false'); }
      function reset() { item.classList.remove('on', 'rg-closed'); mark(false); }

      item.addEventListener('mouseenter', function () { item.classList.remove('rg-closed'); mark(true); });
      item.addEventListener('mouseleave', reset);
      item.addEventListener('focusin', function () { item.classList.remove('rg-closed'); mark(true); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) reset();
      });
      item.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        /* keep focus on the trigger — .rg-closed is what overrides the :hover/:focus-within rule */
        item.classList.remove('on');
        item.classList.add('rg-closed');
        mark(false);
        top.focus();
      });

      if (coarse) {
        top.addEventListener('click', function (e) {
          if (item.classList.contains('on')) return;
          e.preventDefault();
          document.querySelectorAll('[data-rg-sub].on').forEach(function (o) {
            if (o !== item) { o.classList.remove('on'); }
          });
          item.classList.add('on');
          mark(true);
        });
        document.addEventListener('click', function (e) {
          if (!item.contains(e.target)) reset();
        });
      }
    });
  }

  /* publish the measured header height for anything that offsets under it */
  function measure() {
    var top = document.querySelector('.rg-header-section');
    if (!top) return;
    var h = Math.round(top.getBoundingClientRect().height);
    if (h) document.documentElement.style.setProperty('--stack-h', h + 'px');
  }

  function wa() {
    var w = document.querySelector('[data-rg-wa="scroll"]');
    if (!w || w.dataset.rgBound) return;
    w.dataset.rgBound = 'true';
    var last = window.scrollY, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = Math.max(0, window.scrollY), dy = y - last;
        if (Math.abs(dy) < 8) return;
        // away at the top and while reading down, back on the way up
        w.classList.toggle('rg-wa--away', y <= 200 || dy > 0);
        last = y;
      });
    }, { passive: true });
  }


  // the monogram draws itself once it is on screen — started here rather than
  // by the stylesheet, so a slow first paint can't run the animation invisibly.
  // Hovering (or focusing) the brand link runs the whole sequence again.
  function logo(root) {
    (root || document).querySelectorAll('.rg-logo').forEach(function (svg) {
      if (svg.dataset.rgDrawn || reduce) return;
      svg.dataset.rgDrawn = 'true';

      function draw() {
        svg.classList.remove('is-drawing');
        void svg.getBoundingClientRect(); // reflow, so the class re-add restarts the keyframes
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { svg.classList.add('is-drawing'); });
        });
      }

      function replay() {
        var busy = svg.getAnimations && svg.getAnimations({ subtree: true }).some(function (a) {
          return a.playState === 'running';
        });
        if (!busy) draw();
      }

      function start() {
        if (document.visibilityState === 'hidden') {
          document.addEventListener('visibilitychange', function once() {
            if (document.visibilityState !== 'hidden') {
              document.removeEventListener('visibilitychange', once);
              draw();
            }
          });
        } else {
          draw();
        }
      }

      // wait until the mark scrolls into view (footer), header marks start at once
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          io.disconnect();
          start();
        }, { threshold: 0.4 });
        io.observe(svg);
      } else {
        start();
      }

      var host = svg.closest('a') || svg.parentNode;
      if (host) {
        host.addEventListener('mouseenter', replay);
        host.addEventListener('focus', replay, true);
      }
    });
  }

  // footer wordmark: sized to span the full width whatever the brand font,
  // and rises in when the footer scrolls into view
  function fitWord() {
    document.querySelectorAll('.rg-foot__word').forEach(function (w) {
      var sp = w.firstElementChild;
      if (!sp) return;
      var cs = getComputedStyle(w);
      var avail = w.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      if (avail <= 0) return;
      // a few passes, since variable fonts with optical sizing don't scale linearly
      var r = document.createRange();
      var fs = 100;
      for (var i = 0; i < 4; i++) {
        sp.style.fontSize = fs + 'px';
        r.selectNodeContents(sp);
        var tw = r.getBoundingClientRect().width;
        if (!tw) return;
        fs = fs * avail / tw;
      }
      sp.style.fontSize = (fs * 0.99) + 'px';
    });
  }

  var wordRO = 'ResizeObserver' in window ? new ResizeObserver(fitWord) : null;

  function footer(root) {
    fitWord();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitWord);
    if (wordRO) (root || document).querySelectorAll('.rg-foot__word').forEach(function (w) { wordRO.observe(w); });
    else window.addEventListener('resize', fitWord);
    (root || document).querySelectorAll('.rg-foot').forEach(function (f) {
      if (f.dataset.rgFoot || reduce || !('IntersectionObserver' in window)) return;
      f.dataset.rgFoot = 'true';
      f.classList.add('is-pending');
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        f.classList.add('is-in');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { f.classList.remove('is-pending'); });
        });
      }, { threshold: 0.15 });
      io.observe(f);
    });
  }

  function boot(root) { promo(root); drawers(root); subnav(root); logo(root); footer(root); measure(); wa(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  window.addEventListener('resize', measure);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
